import { useContext }                   from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthContext }                  from "../auth/AuthContext";
import { MenuPage }                     from "../components/MenuPage/MenuPage";
import { WithoutMenu }                  from "../components/WithoutMenu";
import { ProtectedAnyRoute }            from "./ProtectedAnyRoute";
import { ProtectedLoginPage }           from "./ProtectedLoginPage";
import { ProtectedRoute }               from "./ProtectedRoute";
import { Hemeroteca } from "../components/Hemeroteca";
import { Configuracion } from "../components/Configuracion";
import { Usuarios} from "../components/Usuarios";

export const AppRouter = () => {
  const {logged} = useContext(AuthContext)

  return (
    <BrowserRouter>
      <Routes>
        {/* Not logged */}
        <Route path="/login" element={<ProtectedLoginPage/>}/>
        <Route path="/" element={<ProtectedAnyRoute/>}/>

        {/* Logged */}
        {/* This conditional is to fix a bad effect UI */}
        {logged && (
        <Route element={<MenuPage/>}>
          <Route path="/hemeroteca" element={<ProtectedRoute path="/hemeroteca"><Hemeroteca/></ProtectedRoute>}/>
          <Route path="/configuracion" element={<ProtectedRoute path="/configuracion"><Configuracion/></ProtectedRoute>}/>
          <Route path="/usuarios" element={<ProtectedRoute path="/usuarios"><Usuarios/></ProtectedRoute>}/>
          <Route path="/without-menu" element={<ProtectedRoute path="/without-menu"><WithoutMenu/></ProtectedRoute>}/>
        </Route>
        )}

        {/* Any route */}
        <Route path="*" element={<ProtectedAnyRoute/>}/>
      </Routes>
    </BrowserRouter>
  );
}